import extend from 'extend';
import { NzSafeAny } from 'ng-zorro-antd/core/types';

/**
 * ç±»ä¼¼ `_.get`ï¼æ ¹æ® `path` è·åå®å¨å¼
 * jsperf: https://jsperf.com/es-deep-getttps://jsperf.com/es-deep-get
 *
 * @param obj æ°æ®æºï¼æ ææ¶ç´æ¥è¿å `defaultValue` å¼
 * @param path è¥ `null`ã`[]`ãæªå®ä¹åæªæ¾å°æ¶è¿å `defaultValue` å¼
 * @param defaultValue é»è®¤å¼
 */
export function deepGet(obj: NzSafeAny | null, path: string | string[] | null | undefined, defaultValue?: NzSafeAny): NzSafeAny {
  if (!obj || path == null || path.length === 0) return defaultValue;
  if (!Array.isArray(path)) {
    path = ~path.indexOf('.') ? path.split('.') : [path];
  }
  if (path.length === 1) {
    const checkObj = obj[path[0]];
    return typeof checkObj === 'undefined' ? defaultValue : checkObj;
  }
  const res = path.reduce((o, k) => (o || {})[k], obj);
  return typeof res === 'undefined' ? defaultValue : res;
}

/**
 * åºäº [extend](https://github.com/justmoon/node-extend) çæ·±åº¦æ·è´
 */
export function deepCopy(obj: NzSafeAny): NzSafeAny {
  const result = extend(true, {}, { _: obj });
  return result._;
}

/**
 * å¤å¶å­ç¬¦ä¸²ææ¡£è³åªè´´æ¿
 */
export function copy(value: string): Promise<string> {
  return new Promise<string>((resolve): void => {
    let copyTextArea: HTMLTextAreaElement | null = null;
    try {
      copyTextArea = document.createElement('textarea');
      copyTextArea.style.height = '0px';
      copyTextArea.style.opacity = '0';
      copyTextArea.style.width = '0px';
      document.body.appendChild(copyTextArea);
      copyTextArea.value = value;
      copyTextArea.select();
      document.execCommand('copy');
      resolve(value);
    } finally {
      if (copyTextArea && copyTextArea.parentNode) {
        copyTextArea.parentNode.removeChild(copyTextArea);
      }
    }
  });
}

/**
 * æ·±åº¦åå¹¶å¯¹è±¡
 *
 * @param original åå§å¯¹è±¡
 * @param arrayProcessMethod æ°ç»å¤çæ¹å¼
 *  - `true` è¡¨ç¤ºæ¿æ¢æ°å¼ï¼ä¸ç®¡æ°å¼ä¸ºåªç§ç±»å
 *  - `false` è¡¨ç¤ºä¼åå¹¶æ´ä¸ªæ°ç»ï¼å°æ§æ°æ®ä¸æ°æ°æ®åå¹¶ææ°æ°ç»ï¼
 * @param objects è¦åå¹¶çå¯¹è±¡
 */
export function deepMergeKey(original: any, arrayProcessMethod: boolean, ...objects: any[]): any {
  if (Array.isArray(original) || typeof original !== 'object') return original;

  const isObject = (v: any) => typeof v === 'object' || typeof v === 'function';

  const merge = (target: any, obj: NzSafeAny) => {
    Object.keys(obj)
      .filter(key => key !== '__proto__' && Object.prototype.hasOwnProperty.call(obj, key))
      .forEach(key => {
        const fromValue = obj[key];
        const toValue = target[key];
        if (Array.isArray(toValue)) {
          target[key] = arrayProcessMethod ? fromValue : [...toValue, ...fromValue];
        } else if (fromValue != null && isObject(fromValue) && toValue != null && isObject(toValue)) {
          target[key] = merge(toValue, fromValue);
        } else {
          target[key] = deepCopy(fromValue);
        }
      });
    return target;
  };

  objects.filter(v => v != null && isObject(v)).forEach(v => merge(original, v));

  return original;
}

/**
 * æ·±åº¦åå¹¶å¯¹è±¡
 *
 * @param original åå§å¯¹è±¡
 * @param objects è¦åå¹¶çå¯¹è±¡
 */
export function deepMerge(original: any, ...objects: any[]): any {
  return deepMergeKey(original, false, ...objects);
}
